<app-back-button></app-back-button>
<div class="header">
  <div class="instituicao-info">
    <div class="name-area">
      <div class="left-area">
        <div class="avatar">
          <p-avatar
            *ngIf="!empresaImageError && imagePreview; else defaultCompanyAvatar"
            [image]="$any(imagePreview)"
            (onImageError)="empresaImageError = true"
            shape="circle"
            size="xlarge"
          />
          <ng-template #defaultCompanyAvatar>
            <p-avatar
              [label]="getInitials(perfilEmpresa?.nome)"
              [icon]="!perfilEmpresa?.nome ? 'pi pi-building' : undefined"
              shape="circle"
              size="xlarge"
            />
          </ng-template>
        </div>
        <div class="title-header">
          <span class="name">{{ perfilEmpresa?.nome }}</span>
          <div class="info">
            <span> <strong>{{ perfilEmpresa?.subSector | subSector}}</strong></span>
            <span>•</span>
            <span><p-tag *ngIf="perfilEmpresa?.estadoContrato === 1" severity="success" value="Activo" />
              <p-tag *ngIf="perfilEmpresa?.estadoContrato === 2" severity="danger" value="Inactivo" /></span>
          </div>
        </div>
      </div>
    </div>
    <div class="contact-info">

      <div class="website">
        <div class="icon">
          <img src="icons/phone.svg" alt="websitte Icon" />
        </div>
        <span>{{ perfilEmpresa?.telefone ||'Não Informado' }}</span>
      </div>

      <div class="website">
        <div class="icon">
          <img src="icons/email.svg" alt="websitte Icon" />
        </div>
        <span>{{ perfilEmpresa?.email ||'Não Informado' }}</span>
      </div>

      <div class="website">
        <div class="icon">
          <img src="icons/globe.svg" alt="websitte Icon" />
        </div>
        <span>{{ perfilEmpresa?.url ||'Não Informado' }}</span>
      </div>

      <div class="address">
        <div class="icon">
          <img src="icons/map-pin.svg" alt="address Icon" />
        </div>
        <span>{{ perfilEmpresa?.localizacao ||'Não Informado' }}</span>
      </div>
    </div>
  </div>
  <div class="indicator">
    <div class="avatars">
      <p-avatar-group *ngIf="companyProfissionais.length > 0; else noProfissionais">
        <p-avatar
          *ngFor="let prof of companyProfissionais"
          [image]="!prof.imageError && prof.photoUrl ? prof.photoUrl : undefined"
          [label]="prof.imageError || !prof.photoUrl ? getInitials(prof.nome) : undefined"
          [icon]="(prof.imageError || !prof.photoUrl) && !prof.nome ? 'pi pi-user' : undefined"
          (onImageError)="prof.imageError = true"
          shape="circle"
          size="large"
          [style]="{ width: '48px', height: '48px' }"
          [pTooltip]="prof.nome"
          tooltipPosition="top"
        />
        <p-avatar
          *ngIf="profissionaisCount > companyProfissionais.length"
          [label]="'+' + (profissionaisCount - companyProfissionais.length)"
          shape="circle"
          size="large"
          [style]="{ width: '48px', height: '48px', 'background-color': '#eef2ff', 'color': '#4864E1', 'font-weight': '600' }"
        />
      </p-avatar-group>
      <ng-template #noProfissionais>
        <p-avatar icon="pi pi-users" shape="circle" size="large" [style]="{ width: '48px', height: '48px' }" />
      </ng-template>
    </div>
    <div class="text">
      <span>{{profissionaisCount}} Profissionais</span>
    </div>
  </div>
</div>
<div class="actions">
  <p-button label="Mais sobre a empresa" icon="pi pi-info-circle" iconPos="right"
    (click)="actionClick(perfilEmpresa?.id)" [outlined]="true" severity="info" />

  <p-button class="Btn-small-auxiliar" label="Editar empresa" icon="pi pi-pen-to-square" iconPos="right"
    [outlined]="true" severity="secondary" (onClick)="showDialog()" *appHasAnyRole="['Actualizar_Empresa_Sector']">
  </p-button>

  <p-button pRipple [label]="getTextoBotaoToggle()" [icon]="getIconeBotaoToggle()"
    [severity]="getSeveridadeBotaoToggle()" [loading]="isLoading" [disabled]="isLoading"
    (click)="toggleEstadoEmpresa()">
  </p-button>
</div>

<p-tabs [(value)]="activeTab" (valueChange)="onTabClick(+$event)">

  <p-tablist>

    <p-tab [value]="0">
      <div class="tab-icon">
        <img src="icons/users-check.svg" alt="user Icon" />
      </div>
      PROFISSIONAIS
    </p-tab>

    <p-tab [value]="1">
      <div class="tab-icon">
        <img src="icons/img-briefcase.svg" alt="user Icon" />
      </div>
      VAGAS
    </p-tab>

    <p-tab [value]="2">
      <div class="tab-icon">
        <img src="icons/calendar.svg" alt="user Icon" />
      </div>
      PLANO DE NECESSIDADES
    </p-tab>

    <p-tab [value]="3">
      <div class="tab-icon">
        <img src="icons/users-01.svg" alt="Email Icon" />
      </div>
      REPRESENTANTES
    </p-tab>

  </p-tablist>

  <p-tabpanels *ngIf="perfilEmpresa">
    <p-tabpanel [value]="0">
      <app-lista-profissionais [perfilEmpresa]="perfilEmpresa"
        (totalProfissionaisChange)="receberTotal($event)"></app-lista-profissionais>
    </p-tabpanel>

    <p-tabpanel [value]="1">
      <app-lista-vagas [perfilEmpresa]="perfilEmpresa"></app-lista-vagas>
    </p-tabpanel>

    <p-tabpanel [value]="2">
      <div class="plano-toolbar">
        <app-search-bar [showPrimaryBtn]="false" [showFilterBtn]="true" (onFilterBtnClick)="showFilter = true"
          (formValueChange)="handleFormValueChange($event)"></app-search-bar>

        <div class="plano-toolbar-actions">
          <app-pdrh [empresaId]="perfilEmpresa?.id ?? empresaId" (imported)="onPdrhImported()"></app-pdrh>
        </div>
      </div>
      @if (pagination.data?.length) {
      <app-table [pagination]="pagination" [columns]="columns" [actions]="actions"
        (pageChange)="onPageChange($event)"></app-table>
      } @else {
      <div class="no-data">
        <app-data-void titulo="Nenhum plano de necessidades encontrado"
          descricao="Aguarde que a empresa crie um plano de necessidades para visualizar aqui."></app-data-void>
      </div>
      }
    </p-tabpanel>
    <p-tabpanel [value]="3">
      <app-lista-representantes [perfilEmpresa]="perfilEmpresa"></app-lista-representantes>
    </p-tabpanel>

  </p-tabpanels>

</p-tabs>

<p-toast></p-toast>
<p-confirmdialog>
  <ng-template #message let-message>
    <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
      <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
      <p>{{ message.message }}</p>
    </div>
  </ng-template>
</p-confirmdialog>

<p-drawer [(visible)]="showDetalhe" position="right" [style]="{'width': '720px'}"
  styleClass="!w-full md:!w-80 lg:!w-[30rem]">
  <ng-template #headless>
    @if (maisDetalheEmpresa) {
    <app-mais-detalhe-empresa [empresaSelected]="maisDetalheEmpresa"
      (onCloseModal)="showDetalhe=false"></app-mais-detalhe-empresa>
    <!--<app-mais-detalhe-vaga [vagaSelected]="maisDetalheVagas" (onCloseModal)="showDetalhe=false"></app-mais-detalhe-vaga>-->
    }
  </ng-template>
</p-drawer>

<p-dialog header="Criar vaga a partir da necessidade" [modal]="true" [(visible)]="showModalAddvaga"
  [style]="{ width: '46rem', maxWidth: '95vw' }" appendTo="body" (onHide)="resetAddVagaForm()">
  <form [formGroup]="formAddVaga" class="p-fluid grid">
    <div class="field col-12 d-flex flex-column">
      <label for="empresaID">Empresa</label>
      <input pInputText formControlName="empresa" class="w-full" id="empresaID" />
    </div>
    <div class="field col-6 d-flex flex-column">
      <label for="profissaoCatologo">Profissão</label>
      <input pInputText formControlName="profissaoCatalogo" class="w-full" id="profissaoCatologo" />
    </div>
    <div class="field col-6 d-flex flex-column">
      <label for="especialidade">Especialidade</label>
      <input pInputText formControlName="especialidadeFuncao" class="w-full" id="especialidade" />
    </div>
    <div class="field col-6 d-flex flex-column">
      <label for="tipoContrato">Tipo de Contrato</label>
      <input pInputText formControlName="tipoContrato" class="w-full" id="tipoContrato" />
    </div>
    <div class="field col-6 d-flex flex-column">
      <label for="NivelAcademico">Nível de Habilitação</label>
      <input pInputText formControlName="nivelHabilitacao" class="w-full" id="NivelAcademico" />
    </div>
    <div class="field col-6 d-flex flex-column">
      <label for="ExperienciaProfissional">Experiência</label>
      <input pInputText formControlName="experiencia" class="w-full" id="ExperienciaProfissional" />
    </div>
    <div class="field col-6 d-flex flex-column">
      <label for="regimeTrabalho">Regime de Trabalho</label>
      <input pInputText formControlName="regimeTrabalho" class="w-full" id="regimeTrabalho" />
    </div>

    <div class="field col-12 d-flex flex-column">
      <label for="descricao">Descrição</label>
      <textarea pTextarea formControlName="descricao" class="w-full" id="descricao" rows="3"
        placeholder="Informação complementar da necessidade"></textarea>
    </div>

    <div class="field col-12 d-flex flex-column">
      <label for="descricaoVaga">Descrição da vaga</label>
      <textarea pTextarea formControlName="descricaoVaga" class="w-full" id="descricaoVaga" rows="4"
        placeholder="Descreva as responsabilidades e os requisitos da vaga"></textarea>
    </div>

    <div class="field col-12 mb-3">
      <div class="mb-3 d-flex align-items-center gap-2">
        <p-checkbox [binary]="true" formControlName="usarNova" inputId="usarNovaCompetencia"></p-checkbox>
        <label for="usarNovaCompetencia">Outra competência</label>
      </div>

      <div *ngIf="!formAddVaga.get('usarNova')?.value" class="mb-2">
        <label class="mb-1">Selecionar competência</label>
        <p-select [options]="listaCompetencias" optionLabel="designacao" optionValue="id"
          formControlName="competenciaID" placeholder="Selecione uma competência" appendTo="body"
          class="w-full"></p-select>
      </div>

      <div *ngIf="formAddVaga.get('usarNova')?.value" class="mb-2">
        <label class="mb-1">Digite a nova competência</label>
        <input pInputText type="text" formControlName="novaCompetencia" placeholder="Nova competência" class="w-full" />
      </div>

      <div class="d-flex justify-content-end">
        <p-button icon="pi pi-plus" label="Adicionar competência" severity="secondary"
          (onClick)="adicionarCompetencia()"></p-button>
      </div>
    </div>

    <div formArrayName="vagaCompetencias" class="field col-12 d-flex flex-wrap gap-2">
      <div *ngFor="let competencia of vagaCompetencias.controls; let i = index"
        class="p-2 border-round bg-body-secondary text-sm flex align-items-center gap-2" [formGroupName]="i">
        <span>
          {{
          competencia.get('usarNova')?.value
          ? competencia.get('novaCompetencia')?.value
          : getNomeCompetencia(competencia.get('competenciaID')?.value)
          }}
        </span>
        <button type="button" class="p-button p-button-text p-button-sm p-button-danger"
          (click)="removeVagaCompetencia(i)">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <div class="field col-6 d-flex flex-column">
      <label for="localizacao">Localização</label>
      <input pInputText formControlName="localizacao" class="w-full" id="localizacao" />
      <small *ngIf="formAddVaga.get('localizacao')?.hasError('required') && formAddVaga.get('localizacao')?.touched"
        class="error-message">
        Localização é obrigatória.
      </small>
    </div>
    <div class="field col-6 d-flex flex-column">
      <label for="dataEncerramento">Data de Encerramento</label>
      <p-datePicker formControlName="dataEncerramento" id="dataEncerramento" [showIcon]="true" class="w-full"
        [showButtonBar]="true" [minDate]="minDataEncerramento" dateFormat="dd/mm/yy" inputId="dataEncerramento"
        appendTo="body"></p-datePicker>
      <small
        *ngIf="formAddVaga.get('dataEncerramento')?.hasError('required') && formAddVaga.get('dataEncerramento')?.touched"
        class="error-message">
        Data de encerramento é obrigatória.
      </small>
    </div>

    <div class="field col-12 d-flex flex-column">
      <label for="numeroVaga">Número de vagas</label>
      <input pInputText type="number" formControlName="numeroVaga" class="w-full" id="numeroVaga" />
      <small *ngIf="formAddVaga.get('numeroVaga')?.hasError('max') && formAddVaga.get('numeroVaga')?.touched"
        class="error-message">
        O número máximo de vagas permitidas é {{ selectedPlano?.vagasDisponivel }}
      </small>
      <small *ngIf="formAddVaga.get('numeroVaga')?.hasError('min') && formAddVaga.get('numeroVaga')?.touched"
        class="error-message">
        Informe pelo menos uma vaga.
      </small>
    </div>

  </form>

  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" [outlined]="true" [disabled]="isSavingVaga"
      (onClick)="showModalAddvaga = false" />
    <p-button label="Criar vaga" icon="pi pi-check" [loading]="isSavingVaga" [disabled]="isSavingVaga"
      (onClick)="salvarVaga()" />
  </div>
</p-dialog>

<p-dialog header="Rejeitar necessidade" [modal]="true" [(visible)]="showModalRejeitarNecessidade"
  [style]="{ width: '32rem', maxWidth: '95vw' }" appendTo="body" [closable]="!isUpdatingEstadoPlano"
  (onHide)="fecharRejeicaoNecessidade()">
  <div class="field d-flex flex-column">
    <label for="motivoRejeicao">Motivo da rejeição</label>
    <textarea pTextarea id="motivoRejeicao" [(ngModel)]="motivoRejeicao" rows="5" class="w-full"
      placeholder="Informe o motivo da rejeição"></textarea>
    <small class="text-secondary">O motivo é obrigatório.</small>
  </div>

  <div class="flex items-center justify-content-between mt-4">
    <p-button label="Cancelar" severity="secondary" [outlined]="true" [disabled]="isUpdatingEstadoPlano"
      (onClick)="fecharRejeicaoNecessidade()" />
    <p-button label="Rejeitar necessidade" icon="pi pi-times" severity="danger" [loading]="isUpdatingEstadoPlano"
      [disabled]="isUpdatingEstadoPlano || !motivoRejeicao.trim()" (onClick)="rejeitarNecessidade()" />
  </div>
</p-dialog>

<p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

  <form [formGroup]="form" class="p-fluid grid">
    <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <label>{{ filter.placeholder }}</label>

      <!-- Se for dropdown -->
      <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
        [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
        [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
      </p-select>

      <!-- Se for texto -->
      <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder" class="w-full" />
    </div>
  </form>


  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
    <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
  </div>
</p-dialog>